define(
'shared/initializer/form/adapters/mixins/SubmitButtonEnableable',['$', 'shared/lib/RSVP','shared/util/registers/ActionProvider'], 
function ($, RSVP, ActionProvider) {
    'use strict';

    // this function is a modified version of bootstrap button()
    function setState(state) {
        var d = 'disabled';
        var showLoadingSpin = 'show-loading-spin';
        var $el  = this;
        if ($el.length <= 0) {
            return;
        }
        var val  = $el.is('input') ? 'val' : 'html';
        var data = $el.data();

        data.loadingText = data.loadingText || 'loading...';

        state = state + 'Text';

        if (!data.resetText) $el.data('resetText', $el[val]());

        $el[val](data[state]);

        if (state == 'loadingText'){
            $el.addClass(d).addClass(showLoadingSpin).attr(d, d) ;
        }
        else {
            $el.removeClass(d).removeClass(showLoadingSpin).removeAttr(d);
        }
    }

    function handleReset(){
        this.$submits.each(function(i, el){
            var $el = $(el);
            setState.call($el, 'reset');    
        });
        return RSVP.resolve.apply(RSVP, arguments.length > 0?arguments:[]);
    }

    function Ctor() { }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var $form = me.$form;

        me.$submits = $form.find('button[type=submit],input[type=submit]');

        return RSVP.resolve()
                .then(function(){
                    return ActionProvider.instance.get($form.attr('id'));
                })
                .then(function( registered ){
                    var submitAction = registered && registered.actions && registered.actions.submit;
                    if (submitAction == null || submitAction.triggers == null) {
                        return;
                    }

                    if ( submitAction.triggers.length > 0 ) {
                        me.$submits = me.$submits.add( submitAction.triggers );
                    }

                    submitAction.triggers.on('add', function( triggers ){
                        me.$submits = me.$submits.add( triggers );
                        me.$submits.removeAttr('disabled');
                    });
                });
    };

    Ctor.prototype.doAfterPageLoad = function() {
        var me = this;

        if ( me.$submits.length > 0 ) {
            me.$submits.removeAttr('disabled');
        }

        return RSVP.resolve();
    };

    Ctor.prototype.doBeforeValidation = function(){
        this.$submits.each(function(i, el){
            var $el = $(el);
            setState.call($el, 'loading');
        });
        return RSVP.resolve();
    };

    Ctor.prototype.doAfterSubmit = function(data){
        if (this.disableButtonAfterSubmit === true) {
            return RSVP.resolve(data);
        }
        return handleReset.call(this, data);
    };

    Ctor.prototype.doSubmitFail = handleReset;
    Ctor.prototype.doValidationFail = handleReset;

    return Ctor;
});
